<moete-rediger-detaljer [skjema]="skjema" data-testid="rediger-protokollførte-møtedetaljer"/>
